module.exports = __webpack_public_path__ + "static/media/Headshot.189b69f9.png";